var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    this.$route.path === "/" ? _c("div") : _vm._e(),
    _c("header", { staticClass: "p-3 text-bg-dark" }, [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          {
            staticClass:
              "d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start",
          },
          [
            _c(
              "div",
              { staticClass: "text-end" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "nav-link px-2 text-white",
                    attrs: { to: "/" },
                  },
                  [
                    _c("img", {
                      staticClass: "logo",
                      attrs: { src: require("../assets/logo.png") },
                    }),
                  ]
                ),
              ],
              1
            ),
            _c(
              "ul",
              {
                staticClass:
                  "nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0",
              },
              [
                _c("li"),
                _c("li"),
                _c("li", [
                  _c("div", { staticClass: "dropdown" }, [
                    _vm.isSignedIn
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "nav-link px-2 text-white dropdown-toggle",
                            attrs: {
                              href: "#",
                              role: "button",
                              "data-bs-toggle": "dropdown",
                              "aria-expanded": "false",
                            },
                          },
                          [_vm._v(" Inventory ")]
                        )
                      : _vm._e(),
                    _c("ul", { staticClass: "dropdown-menu" }, [
                      _vm.isBusiness
                        ? _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { to: "/Venue-List", href: "#" },
                                },
                                [_vm._v("Venues/Events")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "dropdown-item",
                              attrs: { to: "/Bar-Creation", href: "#" },
                            },
                            [_vm._v("Bars")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "dropdown-item",
                              attrs: { to: "/Menu", href: "#" },
                            },
                            [_vm._v("Menu")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "dropdown-item",
                              attrs: { to: "/Bathroom-Creation", href: "#" },
                            },
                            [_vm._v("Bathrooms")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "dropdown-item",
                              attrs: { to: "/Table-Creation", href: "#" },
                            },
                            [_vm._v("Tables")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "dropdown-item",
                              attrs: { to: "/Stage-Creation", href: "#" },
                            },
                            [_vm._v("Stages")]
                          ),
                        ],
                        1
                      ),
                      _c("li"),
                    ]),
                  ]),
                ]),
                _c("li", [
                  _c("div", { staticClass: "dropdown" }, [
                    _vm.isSignedIn
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "nav-link px-2 text-white dropdown-toggle",
                            attrs: {
                              href: "#",
                              role: "button",
                              "data-bs-toggle": "dropdown",
                              "aria-expanded": "false",
                            },
                          },
                          [_vm._v(" Operations ")]
                        )
                      : _vm._e(),
                    _c("ul", { staticClass: "dropdown-menu" }, [
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "dropdown-item",
                              attrs: { to: "/Generate-QR", href: "#" },
                            },
                            [_vm._v("Generate QR")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "li",
                        [
                          _vm.isSignedIn
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { to: "/Live-Orders" },
                                },
                                [_vm._v("Live Orders")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "li",
                        [
                          _vm.isSignedIn
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { to: "/Order-History" },
                                },
                                [_vm._v("Order History/Refunds")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
                _c("li", [
                  _c("div", { staticClass: "dropdown" }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-link px-2 text-white dropdown-toggle",
                        attrs: {
                          href: "#",
                          role: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false",
                        },
                      },
                      [_vm._v(" General Info ")]
                    ),
                    _c("ul", { staticClass: "dropdown-menu" }, [
                      _vm.isSignedIn
                        ? _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { to: "/Instructions" },
                                },
                                [_vm._v("Setup Instructions")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "dropdown-item",
                              attrs: { to: "/PricingPage" },
                            },
                            [_vm._v("Pricing")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "dropdown-item",
                              attrs: { to: "/PrivacyPolicy" },
                            },
                            [_vm._v("Privacy Policy")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "dropdown-item",
                              attrs: { to: "/TermsOfService" },
                            },
                            [_vm._v("Terms Of Service")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
                _vm.isSignedIn
                  ? _c("li", [
                      _c("div", { staticClass: "dropdown" }, [
                        false
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "nav-link px-2 text-white dropdown-toggle",
                                attrs: {
                                  href: "#",
                                  role: "button",
                                  "data-bs-toggle": "dropdown",
                                  "aria-expanded": "false",
                                },
                              },
                              [_vm._v(" Analytics * ")]
                            )
                          : _vm._e(),
                        _c("ul", { staticClass: "dropdown-menu" }, [
                          _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { to: "/Instructions" },
                                },
                                [_vm._v("Revenue Overview")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { to: "/PricingPage" },
                                },
                                [_vm._v("Popular items")]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "nav-link px-2 text-white",
                        attrs: { to: "/About" },
                      },
                      [_vm._v("About")]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "text-end" },
              [
                !_vm.isSignedIn
                  ? _c(
                      "router-link",
                      {
                        staticClass: "btn btn-outline-light me-2",
                        attrs: { to: "/Login" },
                      },
                      [_vm._v("Login")]
                    )
                  : _vm._e(),
                _vm.isSignedIn
                  ? _c(
                      "button",
                      {
                        staticClass: "btn me-2 btnAccent",
                        on: {
                          click: function ($event) {
                            return _vm.logout()
                          },
                        },
                      },
                      [_vm._v("Logout")]
                    )
                  : _vm._e(),
                !_vm.isSignedIn
                  ? _c(
                      "router-link",
                      {
                        staticClass: "btn btnAccent",
                        attrs: { to: "/Signup" },
                      },
                      [_vm._v("Sign-up")]
                    )
                  : _vm._e(),
                _vm.isSignedIn
                  ? _c(
                      "router-link",
                      {
                        staticClass: "btn menuIcon me-2",
                        attrs: { to: "/Accounts" },
                      },
                      [_c("i", { staticClass: "ph-bold ph-gear menuIcon" })]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }